import React from "react";
import { GiPencilBrush } from "react-icons/gi";
import BaseSection from "../components/BaseSection";
import { Grid } from "@material-ui/core";
import ImageUpload from "../components/Input/ImageUpload";
import ColorPickers from "../components/Input/ColorPickers";

export const THEME_SECTION_INPUTS = {
  COMPANY_LOGO: "company_logo",
  COMPANY_LOGIN_IMAGE: "company_login_image",
  COMPANY_COLORS: "company_colors",
  COMPANY_CERTIFICATE_LOGO: "company_certificate_logo"
};

export default function ThemeSection({
  inputs = {},
  errors = {},
  onChangeInput = () => null,
}) {
  return (
    <BaseSection title="Aparência do painel" Icon={<GiPencilBrush />}>
      <Grid container spacing={5}>
        <Grid item xs={5}>
          <ImageUpload
            name={THEME_SECTION_INPUTS.COMPANY_LOGO}
            label="Logo da empresa"
            errorMessage={errors[THEME_SECTION_INPUTS.COMPANY_LOGO]}
            imageUrl={inputs[THEME_SECTION_INPUTS.COMPANY_LOGO]?.url}
            imageFile={inputs[THEME_SECTION_INPUTS.COMPANY_LOGO]?.imageFile}
            onChangeImageFile={(imageFile) =>
              onChangeInput(THEME_SECTION_INPUTS.COMPANY_LOGO, {
                imageFile,
                url: "",
              })
            }
            acceptedExtensions={[".webp", ".png", ".jpg", ".jpeg"]}
            imageSize={{
              width: 400,
              height: 183,
            }}
          />
        </Grid>
        <Grid item xs={5}>
          <ImageUpload
            name={THEME_SECTION_INPUTS.COMPANY_LOGIN_IMAGE}
            label="Imagem de login"
            errorMessage={errors[THEME_SECTION_INPUTS.COMPANY_LOGIN_IMAGE]}
            imageUrl={inputs[THEME_SECTION_INPUTS.COMPANY_LOGIN_IMAGE]?.url}
            imageFile={
              inputs[THEME_SECTION_INPUTS.COMPANY_LOGIN_IMAGE]?.imageFile
            }
            onChangeImageFile={(imageFile) =>
              onChangeInput(THEME_SECTION_INPUTS.COMPANY_LOGIN_IMAGE, {
                imageFile,
                url: "",
              })
            }
            acceptedExtensions={[".webp", ".png", ".jpg", ".jpeg"]}
            imageSize={{
              width: 1920,
              height: 1080,
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Grid item>
            <ColorPickers
              label="Cor do painel"
              colors={inputs[THEME_SECTION_INPUTS.COMPANY_COLORS]}
              onChangeColors={(colors) =>
                onChangeInput(THEME_SECTION_INPUTS.COMPANY_COLORS, colors)
              }
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={5}>
        <Grid item xs={5}>
          <ImageUpload
            disableAspectRatio
            name={THEME_SECTION_INPUTS.COMPANY_CERTIFICATE_LOGO}
            label="Logo do certificado"
            errorMessage={errors[THEME_SECTION_INPUTS.COMPANY_CERTIFICATE_LOGO]}
            imageUrl={inputs[THEME_SECTION_INPUTS.COMPANY_CERTIFICATE_LOGO]?.url}
            imageFile={
              inputs[THEME_SECTION_INPUTS.COMPANY_CERTIFICATE_LOGO]?.imageFile
            }
            onChangeImageFile={(imageFile) =>
              onChangeInput(THEME_SECTION_INPUTS.COMPANY_CERTIFICATE_LOGO, {
                imageFile,
                url: "",
              })
            }
            acceptedExtensions={[".webp", ".png", ".jpg", ".jpeg"]}
            imageSize={{
              width: 400,
              height: 400,
            }}
          />
        </Grid>
      </Grid>
    </BaseSection>
  );
}
